<template>
  <div class="text-center">
    <form :class="content && content.cssClass" class="relative contact" v-on:submit.prevent="submitContactForm" v-animate-onscroll="'animated fadeIn'">
      <h3 v-if="content.heading" v-html="content.heading" :class="`${false ? 'opacity-0 delay-200' : ''}  ${content.subhead ? 'pt-2 pb-2':'py-6'}`" v-animate-onscroll="'animated fadeIn'"></h3>
      <h4 v-if="content.subhead" v-html="content.subhead" :class="`${false ? 'opacity-0 delay-200' : ''} pb-2 text-center text-white`" v-animate-onscroll="'animated fadeIn'"></h4>



      <div class="px-6 py-6 pb-8 mt-2 bg-white sm:px-10">
        <div class="flex flex-wrap">
          <div v-for="f,i in fields" :key="f.index" :class="`relative mb-6   sm:mb-8 ${getWidth(f,i)} ${errors.indexOf(f.name) > -1 ? 'error' : ''} ${f.showKey && f.showValue.indexOf(model[f.showKey]) < 0 ? 'hidden' : ''}`" :data-error="f.errorMsg">
            <div v-if="!f.showKey || f.showValue.indexOf(model[f.showKey]) > -1">
              <label :for="f.name" :class="`main-label`" v-html="f.label" />
              <div v-if="f.type == 'textarea'">
                <textarea :id="f.name" :name="f.name" :placeholder="f.label" @keyup="getCharsRemaining(f.name)" v-model="model[f.name]" maxlength="256"></textarea>
                <span class="float-left">* No special characters allowed except /</span>
                <span class="float-right">{{charsRemaining}} Characters Remaining</span>
              </div>
              <div v-else-if="f.type == 'date'">
                <date-field :field="f" :model="model[f.name]" :handleUpdate="onCalendarChange" />
              </div>
              <div v-else-if="f.type == 'select'">
                <mobile-select v-if="mobile" :field="f" :model="model" :handleUpdate="updateSelect" />
                <default-select v-else :field="f" :model="model" :handleUpdate="updateSelect" />
              </div>
              <div v-else-if="f.type == 'checkbox'" class="flex">
                <input type="checkbox" :id="f.name" :name="f.name" v-model="model[f.name]" />
                <label :for="f.name" v-html="f.label" />
              </div>
               <div v-else-if="f.type == 'group'" class="flex flex-wrap w-full">
                    <div class="w-full" v-if="f.repeatable">
                         <div class="w-full mb-4 font-bold uppercase"> {{f.label}}</div>
                          <div class="relative flex flex-wrap items-center w-full" v-for="(fg,j) in f.fields" :key="j">
                            <div class="flex flex-wrap items-center w-11/12 lg:flex-row">
                               <div v-for="cfg, g in fg.field_group" :key="g" :class="`relative flex w-full flex-wrap lg:w-1/2 ${even(g) ? 'lg:mb-0 pr-3 lg:pr-8':'pr-3 lg:pr-0 mb-4 lg:mb-0'}`" >
                                   <div class="relative flex w-full" v-if="cfg.type === 'simple-date' && model[f.name] && model[f.name][i]">
                                           <input :type="cfg.type" v-mask="'##/##/####'" :id="cfg.name" :name="cfg.name" :placeholder="cfg.label" :v-model="model[cfg.name]" />
                                   </div>
                                   <div v-else class="flex w-full">
                                   <input :type="cfg.type" :id="cfg.name" :name="cfg.name" :placeholder="cfg.label" v-if="model[f.name]" :v-model="model[cfg.name]" />
                                  </div>
                               </div>
                            </div>
                           <a href="#remove" v-if="j !== 0"   @click.prevent="removeSet(f.name,i,j)" class="absolute top-0 right-0 flex items-center justify-center w-6 h-6 mt-6 font-bold uppercase transition-all duration-200 border-2 border-black rounded-full lg:mt-1 hover:bg-black hover:text-white ease">  -    </a>





                            <a href="#add" v-if="j === f.fields.length-1" @click.prevent="addFieldSet(f.name,fg,i)" class="flex items-center justify-center w-full py-2 mt-4 font-bold uppercase border-2 border-black">  + <div class="ml-2 text-xs font-bold">{{fg.add_label}}</div>   </a>
                          </div>
                    </div>
                     <div v-else class="flex flex-wrap w-full">
                       <div class="w-full mb-8 font-bold uppercase"> {{f.label}}</div>

                          <div class="w-full lg:w-1/2" v-for="(fg,i) in f.fields" :key="i">
                               <div v-if="fg.type === 'checkbox'" class="flex pb-8">
                                <input type="checkbox" v-if="model[f.name]" @change="setCheckBoxValue(f.name,i,fg.name, $event)" :id="fg.name" :name="fg.name" :value="model[f.name][i]" />
                                <label class="uppercase" :for="fg.name" v-html="fg.label" />
                              </div>

                          </div>
                    </div>
              </div>
               <div class="relative" v-else-if="f.type == 'simple-date'">
                   <input :type="f.type" v-mask="'##/##/####'" :id="f.name" :name="f.name" :placeholder="f.label" v-model="model[f.name]" />
               </div>
                <input v-else-if="f.type === 'tel'" :type="f.type" v-mask="'###-###-####'" :id="f.name" :name="f.name" :placeholder="f.label" v-model="model[f.name]" />

              <input v-else :type="f.type" :id="f.name" :name="f.name" :placeholder="f.label" v-model="model[f.name]" />
            </div>
          </div>
        </div>

        <div v-if="sending">
          <loader color="purple" />
        </div>
        <div v-else-if="complete" class="text-center">
          <!-- <div>Thank You!<br/>A member of our team will be in touch with you shortly.</div> -->
        </div>
        <div v-else class="flex flex-wrap items-center">
          <button class="pulse purple">{{defaults && defaults.ButtonName || 'submit '}}</button>
          <div v-if="error" class="mt-4 lg:mt-10 lg:ml-4">
            <error-basic />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import moment from 'moment'
import { detect } from 'detect-browser'

import Loader from './Loader'
import DefaultSelect from '../forms/Select'
import MobileSelect from '../forms/MobileSelect'
import DateField from '../forms/DateField'
const states = require('~/assets/config/states.json')
const emarsysFields = require('~/assets/config/emarsysForm.json')
import { setWith, set, merge } from 'lodash'
import ErrorBasic from './ErrorBasic.vue'

export default {
  components: {
    Loader,
    DefaultSelect,
    MobileSelect,
    DateField,
    ErrorBasic
  },
  props: {
    content: {
      type: Object,
    },
    animate: {
      type: Boolean
    },
    defaults: {
      type: Object
    },
    formName: {
      type: String
    },
    sendKey: {
      type: String
    },
    formData: {
      type: Array
    }
  },
  data: function() {
    let fields = []
    let model = {}

    let formFields = this.formData || emarsysFields
    formFields.map(f => {
      if(f.name == 'Location') {
        let stateOpts = {}
        Object.keys(this.$store.state.centerData).map(c => {
          let center = this.$store.state.centerData[c]
          if(!stateOpts[center.state]) {
            stateOpts[center.state] = {
              title: states[center.state],
              values: []
            }
          }
          stateOpts[center.state].values.push({
            value: c,
            title: `${center.name}, ${center.state}`
          })
        })

        let locations = []
        Object.keys(stateOpts).map(s => {
          stateOpts[s].values.sort(this.sortOptions)
          locations.push(stateOpts[s])
        })
        locations.sort(this.sortOptions)

        f.options = locations
      }
      fields.push(f)
      model[f.name] = null
    })

    return {
      charsRemaining: 256,
      calendar: null,
      fields: fields,
      model: model,
      errors: [],
      sending: false,
      complete: false,
      error: false
    }
  },
  computed: {
     emtpyData() {
      return this.fields.map(() => {
        return ''
      })
    },
    mobile() {
      const browser = detect()
      if(browser) {
        switch(browser.os) {
          case 'iOS':
          case 'Android OS':
            return true
            break
          default:
            return false
        }
      } else {
        return false
      }
    },
    minDate() {
      return ''
    }
  },
  mounted() {
    // if (this.$route.path.match('/family-zone-eclub/')) {
    // console.log(this.$route.path)
    // } else {
    //   console.log('figure it out')
    // }
    this.model.smsOptIn = true
    if(this.defaults) {
      Object.keys(this.defaults).map(k => {
        this.model[k] = this.defaults[k]
      })

    if(this.$store.state.zipcode) {
      this.model.zipcode = this.$store.state.zipcode
    }

     this.fields.filter((f)=>{
         return f.fields && f.fields.length
       }).map((fg,j)=>{
          if(fg.fields[j].field_group){
          this.model[fg.name] =  fg.fields.map((n)=> {
             // const fmap = {...n.field_group.map((f)=> f.name )}
            return {
              name: '',
              child_birthday: ''
            }
            // const p =   {...n.field_group.map((f)=> setWith({},  f.name, '')  )  }
            // return  p
           })
         }else{
           this.model[fg.name] =  fg.fields.map((n,i)=> {
            const k = fg.fields[i].name
            return  setWith({}, k, false);
           })
         }
       })
    }


  },
  methods: {
    even(number) {
      return number % 2 === 0
    },
    setCheckBoxValue(n,i,fname,$event){
      // sets the custom value to the checkbox
       set(this.model[n][i],fname,$event.target.checked );
     },
     removeSet(n,i, d){
       console.log(n,i,d);
       this.fields[i].fields.splice(d, 1)
     },
    addFieldSet(n,fg,i){

      //  console.log( this.model[n]);
      const clonedField = this.fields[i].fields[0]
      this.fields[i].fields.push(clonedField)

    },
    async submitContactForm() {
      let errors = []
      let source = null
      if (this.$route.path.match('/family-zone-eclub') || this.$route.path.match('/family-zone-eclub/')) {
        source = 'Cowboys'
      }
      if (this.$route.path.match('/eclub-social') || this.$route.path.match('/eclub-social/')) {
        source = 'Social'
      }
      if (this.$route.path.match('/birthday-sms') || this.$route.path.match('/birthday-sms/')) {
        source = 'Birthday_SMS'
      }
      if (this.$route.path.match('/trash-panda-eclub-signup') || this.$route.path.match('/trash-panda-eclub-signup/')) {
        source = 'Trash Pandas'
      }
      if (this.$route.path.match('/nco') || this.$route.path.match('/nco/')) {
        source = 'NCO'
      }
      let data = {
        emailOptIn: this.model.emailOptIn || false,
        source: source,
        // smsOptIn: this.model.smsOptIn || false,
      }
      if(this.model.smsOptIn) {
        data.smsOptIn = true
      }
      this.fields.map(f => {
        if(!this.validate(f)) {
          errors.push(f.name)
        }
        switch(f.name) {
          case 'firstName':
            data.firstName = this.model[f.name]
            break
          case 'lastName':
            data.lastName = this.model[f.name]
            break
          case 'Email':
            data.emailAddress = this.model[f.name]
            break
          case 'Location':
            data.preferredLocation = this.model[f.name]
            break
          case 'mobilePhone':
            if(this.model.smsOptIn == true && (!this.model[f.name] || !this.model[f.name].match(/^[\(]?[1-9]{1}[0-9]{2}[\)\s\-\.]*[1-9]{1}[0-9]{2}[\s\-\.]?[0-9]{4}/))) {
              errors.push(f.name)
            } else if(this.model[f.name]) {
              data.mobilePhone = this.model[f.name]
            }
            break
        }
      })
      this.errors = errors

      console.log('test data: ', data)

      if(errors.length < 1 && this.sending == false && this.complete == false) {
        this.sending = true
        this.error = true
        let status = null
        try {
          status = await this.$mulesoftv3.submitContact(data)
        } catch(err) {
          this.error = true
        }
        // let status = await this.$axios.post(`${this.$api.url()}mailgun`, {
        //   table: this.formName || 'Web Booking',
        //   sendTo: this.sendKey ? this.model[this.sendKey] : this.model.Location,
        //   fields: this.model
        // })
        this.sending = false
        this.complete = true
        // simulate redirect
        if(status) {
          this.$nuxt.$router.push(this.defaults.RouteTo)
        //  setTimeout(() => {
        //     if(this.defaults.RouteTo) this.$nuxt.$router.push(this.defaults.RouteTo)
        //  }, 3000);
        }
      }
    },
    validate(f) {
      switch(f.type) {
        case 'checkbox':
          if(f.required && this.model[f.name] != true) {
            return false
          }
          break
        case 'date':
          if(f.required && this.model[f.name] == null) {
            return false
          }
          break
        case 'tel':
          if(f.required || (this.model[f.name] != null && this.model[f.name] != '')) {
            return this.model[f.name] && this.model[f.name].match(/^[\(]?[1-9]{1}[0-9]{2}[\)\s\-\.]*[1-9]{1}[0-9]{2}[\s\-\.]?[0-9]{4}/)
          }
          break
        case 'email':
          return this.model[f.name] && this.model[f.name].match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
          break
        default:
          if((f.required && !f.showKey) || (f.required && f.showValue.indexOf(this.model[f.showKey]) > -1) || (this.model[f.name] != null && this.model[f.name] != '')) {
            return this.model[f.name] && this.model[f.name].match(/^[A-Za-z0-9]+/)
          }
      }
      return true
    },
    openCalendar(cal) {
      this.calendar = cal
    },
    formatDate(f) {
      if(this.model[f.name] == null) {
        return f.label
      } else {
        return moment(this.model[f.name]).format(f.format)
      }
    },
    onCalendarChange(d) {
      this.model[d.name] = d.date.format('MM/DD/YYYY')
    },


    updateSelect(name, value) {
      this.model[name] = value
    },
    getCharsRemaining(field) {
      if(this.model[field]) {
        this.charsRemaining = 256 - this.model[field].length
      }
    },
    getWidth(f,i) {
      if(f.width) {
        if(f.width == 'full') {
          return 'w-full  '
        } else if(f.width == 'auto') {
          return ''
        }
      }

      return `w-full sm:w-1/2 ${this.even(i) ?'sm:pr-8':''}`
    },
    sortOptions(a, b) {
      if(a.title < b.title) {
        return -1
      } else if(a.title > b.title) {
        return 1
      } else {
        return 0
      }
    }
  },
}
</script>

<style lang="scss">
.locked {
  &, & > * {
    opacity: 1 !important;
  }
}
.contact.contact-bottom, .contact.bottom {
  margin-bottom: -5px;
}
</style>
